export default __webpack_public_path__ + "static/media/accordion-plus-icon.a9dd8ee3.svg";